/**
 * #294: archived chats stay searchable and individually pickable, but a BULK add
 * (select-all, the type filter, label expansion) must not sweep them into an audience
 * unless the user asks for them one by one.
 */
export interface BulkSelectableContact {
    archived?: boolean;
}

export function excludeArchivedFromBulk<T extends BulkSelectableContact>(contacts: readonly T[]): T[] {
    return contacts.filter((contact) => contact?.archived !== true);
}

/**
 * The de-duplicated chat ids a label expands to, minus archived chats. The lookup returns the
 * cached contact for a chat id (undefined when it is not cached, which still counts).
 */
export function labelExpansionWaChatIds(
    contactLabels: ReadonlyArray<{ waChatId?: string }>,
    lookup: (waChatId: string) => BulkSelectableContact | undefined,
): string[] {
    const seen = new Set<string>();
    const ids: string[] = [];
    for (const { waChatId } of contactLabels) {
        if (!waChatId || seen.has(waChatId)) continue;
        seen.add(waChatId);
        if (lookup(waChatId)?.archived === true) continue;
        ids.push(waChatId);
    }
    return ids;
}
